import { render, staticRenderFns } from "./AddUpdateCoupons.vue?vue&type=template&id=b5f47628&scoped=true"
import script from "./AddUpdateCoupons.vue?vue&type=script&lang=js"
export * from "./AddUpdateCoupons.vue?vue&type=script&lang=js"
import style0 from "./AddUpdateCoupons.vue?vue&type=style&index=0&id=b5f47628&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5f47628",
  null
  
)

export default component.exports